module.exports = __webpack_public_path__ + "static/media/111.7efd5870.jpg";